import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    backdropFilter: "blur(18px)",
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    top: 0,
    position: "absolute",
    zIndex: theme.zIndex.dialog,
  },
  service: {
    display: "grid",
    gridGap: theme.spacing.space40,
    gridTemplateColumns: "repeat(auto-fill, minmax(70px, 1fr))",
    marginTop: 90,
    padding: `0 ${theme.spacing.space24}px`,
    justifyContent: "space-between",
  },
  rowService: {
    display: "flex",
    flexDirection: "row",
  },
  forwardsAnimate: {
    animation: `$forwardsAnimate 0.3s ease-in`,
    overflow: "scroll",
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  backwardsAnimate: {
    animation: `$backwardsAnimate 0.3s ease-in`,
    overflow: "scroll",
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  icon: {
    color: theme.colors.Background7,
  },
  "@keyframes forwardsAnimate": {
    "0%": {
      transform: "translateY(-100%)",
    },
    "100%": {
      transform: "translateY(0%)",
    },
  },
  "@keyframes backwardsAnimate": {
    "0%": {
      transform: "translateY(0%)",
    },
    "100%": {
      transform: "translateY(-100%)",
    },
  },
}));
